import React from "react";

const CHUNK_ERROR_RE = /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

export default class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("MKTRANSFE page error:", error, info);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
            this.setState({ error: null });
        }
    }

    handleRetry = () => {
        const message = String(this.state.error?.message || this.state.error || "");
        if (CHUNK_ERROR_RE.test(message)) {
            window.location.reload();
            return;
        }
        this.setState({ error: null });
    };

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className="min-h-screen bg-[#050d17] px-5 py-10 text-white">
                <div className="mx-auto mt-[12vh] max-w-lg rounded-[28px] border border-white/10 bg-white/[0.05] p-6 text-center shadow-2xl shadow-black/30 backdrop-blur-xl">
                    <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-amber-500/15 text-2xl">!</div>
                    <h1 className="mt-5 text-2xl font-black">Paj la pa t chaje nèt</h1>
                    <p className="mt-3 text-sm leading-6 text-white/60">
                        Sa ka rive si entènèt la koupe yon moman oswa si yon pati nan aplikasyon an poko fin chaje. Tranzaksyon ou pa chanje poutèt ekran sa a.
                    </p>
                    <div className="mt-6 grid gap-3 sm:grid-cols-2">
                        <button
                            type="button"
                            onClick={this.handleRetry}
                            className="rounded-2xl bg-blue-600 px-4 py-3 text-sm font-black text-white hover:bg-blue-500"
                        >
                            Eseye ankò
                        </button>
                        <button
                            type="button"
                            onClick={() => { window.location.href = "/"; }}
                            className="rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3 text-sm font-black text-white/80 hover:bg-white/[0.08]"
                        >
                            Retounen lakay
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
